import { createContext, useContext, useState, useEffect } from "react";
import ModalToast from "./ModalToast";

const ModalToastContext = createContext();

export const ModalToastProvider = ({ children }) => {
  const [modal, setModal] = useState(null);

  const show = (message, type = "error") => {
    setModal({ message, type });
  };

  const hide = () => setModal(null);

  const isOpen = !!modal;

  // 🔥 BLOCK ENTER KEY + FORM SUBMIT GLOBALLY
  useEffect(() => {
    if (!isOpen) return;

    const blockEnterSubmit = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    const blockSubmit = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    document.addEventListener("keydown", blockEnterSubmit, true);
    document.addEventListener("submit", blockSubmit, true);

    return () => {
      document.removeEventListener("keydown", blockEnterSubmit, true);
      document.removeEventListener("submit", blockSubmit, true);
    };
  }, [isOpen]);

  return (
    <ModalToastContext.Provider value={{ show, hide, isOpen }}>
      {children}
      {modal && (
        <ModalToast
          message={modal.message}
          type={modal.type}
          onClose={hide}
        />
      )}
    </ModalToastContext.Provider>
  );
};

export const useModalToast = () => useContext(ModalToastContext);